import { render, staticRenderFns } from "./GroupsSelectDropdown.vue?vue&type=template&id=bf870ee0&scoped=true"
import script from "./GroupsSelectDropdown.vue?vue&type=script&lang=ts"
export * from "./GroupsSelectDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf870ee0",
  null
  
)

export default component.exports